import React from 'react';
import BottomButtonsNew from '../../shared/BottomButtonsNew/BottomButtonsNew';
import { MainLogo } from '../../constants/assets';
// import { MainPinata } from '../../constants/assets';

const Discover = props => {
    const goToNext = () => {
        const { history } = props;
        history.push("/prize-list");
    }

    return (
        <div className="discover-page text-center">
            <h1>En estas fiestas,</h1>
            <MainLogo customClass="welcome-logo" />
            <p>
                quiere regalarte algo<br/>
                <span className="font-sep">muy especial</span><br />
                para que sigas cocinando con amor.
            </p>
            <BottomButtonsNew
                btn1={{
                    btnAction: goToNext,
                    customClass: 'next-button-new'
                }}
            />
            { /*
            <h1>¿Te gustaría descubrir<br />de qué se trata?</h1>
            <MainPinata />
            <BottomButtonsNew
                btn1={{
                    btnAction: goToNext,
                    customClass: 'next-button'
                }}
                logo
            />
            */ }
        </div>
    );
};

export default Discover;
